// resources/js/Pages/HallOfFame/components/VideoModal.jsx
import React, { useEffect, useRef, useState } from 'react';

export default function VideoModal({ isOpen, onClose, initialScript, allScripts }) {
    const videoRef = useRef(null);
    const [currentScript, setCurrentScript] = useState(initialScript);
    const [suggestions, setSuggestions] = useState([]);
    
    // Update current script when initialScript changes
    useEffect(() => {
        if (initialScript) {
            setCurrentScript(initialScript);
        }
    }, [initialScript]);
    
    // Get 3 random suggestions (excluding current script)
    useEffect(() => {
        if (!isOpen || !allScripts || !currentScript) return;
        
        const otherScripts = allScripts.filter(s => s.id !== currentScript.id && s.video_url);
        const shuffled = [...otherScripts].sort(() => 0.5 - Math.random());
        setSuggestions(shuffled.slice(0, 3));
    }, [isOpen, currentScript, allScripts]);
    
    // Auto-play video when script changes
    useEffect(() => {
        if (isOpen && videoRef.current) {
            videoRef.current.load();
            videoRef.current.play();
        }
    }, [isOpen, currentScript]);
    
    if (!isOpen || !currentScript) return null;
    
    const handleSuggestionClick = (suggestedScript) => {
        setCurrentScript(suggestedScript);
    };
    
    return (
        <div 
            className="modal fade show" 
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.7)' }}
            onClick={onClose}
        >
            <div 
                className="modal-dialog modal-lg modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="modal-content bg-dark text-white">
                    {/* Header */}
                    <div className="modal-header border-secondary">
                        <h5 className="modal-title">{currentScript.title}</h5>
                        <button 
                            type="button" 
                            className="btn-close btn-close-white" 
                            onClick={onClose}
                        ></button>
                    </div>
                    
                    {/* Video */}
                    <div className="modal-body p-0">
                        <video 
                            ref={videoRef}
                            width="100%" 
                            controls 
                            autoPlay
                            className="w-100"
                        >
                            <source src={currentScript.video_url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    
                    {/* Suggestions */}
                    {suggestions.length > 0 && (
                        <div className="modal-footer border-secondary flex-column align-items-start">
                            <h6 className="text-white mb-3">Watch another:</h6>
                            <div className="row g-3 w-100">
                                {suggestions.map(suggested => (
                                    <div key={suggested.id} className="col-4">
                                        <div 
                                            className="suggestion-item"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleSuggestionClick(suggested)}
                                        >
                                            {suggested.poster_url && (
                                                <img 
                                                    src={suggested.poster_url}
                                                    alt={suggested.title}
                                                    className="img-fluid rounded mb-2"
                                                    loading="lazy"
                                                    style={{ aspectRatio: '16/9', objectFit: 'cover' }}
                                                />
                                            )}
                                            <p className="text-white small mb-0 text-truncate">
                                                {suggested.title}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
